import { render, staticRenderFns } from "./CatIcon.vue?vue&type=template&id=5cc597e0&scoped=true"
import script from "./CatIcon.vue?vue&type=script&lang=ts"
export * from "./CatIcon.vue?vue&type=script&lang=ts"
import style0 from "./CatIcon.vue?vue&type=style&index=0&id=5cc597e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc597e0",
  null
  
)

export default component.exports